import {IntermediatePart} from "../../intermediatePart";
import {Vanity} from "../../parts/vanity";
import {createParentPositions, SIDE_POSITIONS, VANITY_TYPES} from "../../constants";
import {updateSinkWithNewFeature} from "../../../lookNavigation/lookNavigationFunctions";

export default class VanityWashstand extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_washstand';
    this.partName = 'Washstand';
    this.translateId = "visualizer.bathroom.vanity.vanity_washstand";
    this.visible = [Vanity.Types.Custom];
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  disabledClick() {
    this.toggleLayerPositions();
    const vanityParent = this.getParent();
    if (vanityParent && vanityParent.wsTowelBar) {
      vanityParent.wsTowelBar.disabled = this.disabled || !vanityParent.wsTowelBar.canBeEnabled(); // true or check if it can be enabled;;
    }
  }

  handleClick(ignoreLocked) {
    const vanityParent = this.getParent().getParent();
    vanityParent.vanity_type = VANITY_TYPES.vanity_washstand;
    super.handleClick(ignoreLocked);
    updateSinkWithNewFeature(this);
    vanityParent.updateVanityParts();
  }

  hideLayerCondition() {
    const vanityParent = this.getParent();
    return vanityParent.vanity_type !== VANITY_TYPES.vanity_washstand && !!this.activeFeature
  }

  // getArrayOfConditions() {
  //   const conditions = super.getArrayOfConditions();
  //   const activeMatchingSink = this.getParent().getActiveSkuFromRelatedItem("vanity_sink");
  //   if (activeMatchingSink) {
  //     conditions.push({
  //       propName: "MatchingFeature",
  //       propValue: activeMatchingSink
  //     });
  //   }
  //   return conditions
  // }

  canDisplayDemoPoint(parentObject) {
    return this.getParent().vanity_type === VANITY_TYPES.vanity_washstand && (parentObject.layerPosition !== SIDE_POSITIONS[0])
  }

}
